import { FC } from 'react'
import { useQuery } from '@apollo/client'
import { useSearchParams } from 'react-router-dom'
import { validateRequired } from 'utils/validation'
import { SelectField } from 'components/Select'
import { FIND_ALL_STRATEGY_GROUP } from 'queries/strategies'
import { findAllStrategyGroup, findAllStrategyGroupVariables } from '__generatedTypes__/findAllStrategyGroup'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'

export const SELECTED_SUBJECT_ID_PARAM = 'subject-id'

export const GroupSelect: FC = () => {
  const [searchParams] = useSearchParams()

  const { data, loading } = useQuery<findAllStrategyGroup, findAllStrategyGroupVariables>(FIND_ALL_STRATEGY_GROUP, {
    variables: {
      query: {
        take: TAKE_ALL_ITEMS_COUNT,
        where: {
          subject: {
            id: String(searchParams.get(SELECTED_SUBJECT_ID_PARAM)),
          },
        },
      },
    },
  })

  const items = data?.findAllStrategyGroup?.items || []

  return (
    <SelectField
      name="strategyGroup"
      placeholder="Select group"
      items={items}
      renderItem={(item) => item.title}
      getItemLabel={(item) => item.title}
      label="Group"
      fullWidth
      validate={validateRequired}
      loading={loading}
    />
  )
}
